'use client';

import type { AudioOption } from '@/app/types';
import { SITE } from './site';

export const IMG_DEFAULT =
  SITE === 'china'
    ? 'https://image01.vidu.zone/vidu/media-asset/audio-default-img-0a2fa1c3.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/audio-default-img-0a2fa1c3.webp';

export const IMG_CUSTOM_VOICE_DEFAULT =
  SITE === 'china'
    ? 'https://image01.vidu.zone/vidu/media-asset/custom_voice_cover-09ba6aca.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/custom_voice_cover-09ba6aca.webp';

// 国内的
const TIMBRE_LIST_CHINA: AudioOption[] = [
  {
    id: 'Boyan_new_platform',
    name: '绅士青年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/boyan-new-platform-2da38540.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Boyan_new_platform-807fdeb6.mp3',
  },
  {
    id: 'Chinese (Mandarin)_BashfulGirl',
    name: '害羞少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-bashfulgirl-c44abfab.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__BashfulGirl-97a2f1af.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Crisp_Girl',
    name: '清冷少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-crisp-girl-25d42413.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Crisp_Girl-c7f6c2b4.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Cute_Spirit',
    name: '灵动精灵',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-cute-spirit-27dcfc65.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Cute_Spirit-324df851.mp3',
  },
  {
    id: 'Chinese (Mandarin)_ExplorativeGirl',
    name: '探索少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-explorativegirl-211d385a.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__ExplorativeGirl-a864d166.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Gentle_Youth',
    name: '温柔少年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-gentle-youth-be4e2fea.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Gentle_Youth-ffc00392.mp3',
  },
  {
    id: 'Chinese (Mandarin)_IntellectualGirl',
    name: '睿智少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-intellectualgirl-d6b00c5a.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__IntellectualGirl-f3486a49.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Kind-hearted_Elder',
    name: '仁爱长者',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-kind-hearted-elder-9ad2a24a.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Kind_hearted_Elder-d594bcb8.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Laid_BackGirl',
    name: '慵懒少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-laid-backgirl-8e880b16.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Laid_BackGirl-092ff445.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Male_Announcer',
    name: '雄浑播音',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-male-announcer-920cacf6.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Male_Announcer-e600048d.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Pure-hearted_Boy',
    name: '纯真少年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-pure-hearted-boy-9cc139b8.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Pure_hearted_Boy-b9827ca2.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Sincere_Adult',
    name: '诚恳大人',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-sincere-adult-7a1dee62.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Sincere_Adult-4f5ab909.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Soft_Girl',
    name: '柔和少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-soft-girl-3652a59a.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Soft_Girl-e58f9505.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Straightforward_Boy',
    name: '直率少年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-straightforward-boy-6cddfd51.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Straightforward_Boy-4033bebf.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Stubborn_Friend',
    name: '倔强挚友',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-stubborn-friend-19315b14.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Stubborn_Friend-ef991707.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Warm_Bestie',
    name: '暖心闺蜜',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-warm-bestie-35db0199.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Warm_Bestie-dcab2336.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Warm_HeartedGirl',
    name: '善良少女',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-warm-heartedgirl-5d58fd5e.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Warm_HeartedGirl-9d747ecf.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Warm-HeartedAunt',
    name: '慈爱阿姨',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-warm-heartedaunt-7b7d83e5.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Warm_HeartedAunt-3568a3f0.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Wise_Women',
    name: '睿智女性',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-wise-women-4fbf7aec.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__Wise_Women-783c6b8b.mp3',
  },
  {
    id: 'Chinese (Mandarin)_HK_Flight_Attendant',
    name: '港式空姐',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chinese-mandarin-hk-flight-attendant-dfc0a9a4.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Chinese__Mandarin__HK_Flight_Attendant-0e6a6a95.mp3',
  },
  {
    id: 'Robot_Armor',
    name: '机甲音',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/robot-armor-8525c489.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Robot_Armor-5486ccee.mp3',
  },
  {
    id: 'male-qn-qingse-jingpin',
    name: '青涩青年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/male-qn-qingse-jingpin-674eacef.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/male_qn_qingse_jingpin-7bd88790.mp3',
  },
  {
    id: 'male-qn-jingying-jingpin',
    name: '精英青年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/male-qn-jingying-jingpin-cf10e3e1.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/male_qn_daxuesheng_jingpin-3d93baad.mp3',
  },
  {
    id: 'male-qn-badao-jingpin',
    name: '霸道青年',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/male-qn-badao-jingpin-516cf05d.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/male_qn_badao_jingpin-39911a67.mp3',
  },
  {
    id: 'male-qn-daxuesheng-jingpin',
    name: '男学生',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/male-qn-daxuesheng-jingpin-0a7ed428.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/male_qn_daxuesheng_jingpin-3d93baad.mp3',
  },
  {
    id: 'female-shaonv-jingpin',
    name: '女学生',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/female-shaonv-jingpin-720c455e.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/female_shaonv_jingpin-d3bdebb9.mp3',
  },
  {
    id: 'female-yujie-jingpin',
    name: '御姐音色',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/female-yujie-jingpin-94286cf3.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/female_yujie_jingpin-b50cbb01.mp3',
  },
  {
    id: 'female-chengshu-jingpin',
    name: '成熟女性',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/female-chengshu-jingpin-7ca5adb6.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/female_chengshu_jingpin-450f8043.mp3',
  },
  {
    id: 'female-tianmei-jingpin',
    name: '甜美女性',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/female-tianmei-jingpin-271ea306.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/female_tianmei_jingpin-8780ca4c.mp3',
  },
  {
    id: 'clever_boy',
    name: '聪明男童',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/clever-boy-698ed9bd.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/clever_boy-1c475a54.mp3',
  },
  {
    id: 'cute_boy',
    name: '可爱男童',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/cute-boy-93b0bd3c.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/cute_boy-b3b78075.mp3',
  },
  {
    id: 'lovely_girl',
    name: '萌萌女童',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/lovely-girl-d146a0af.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/lovely_girl-d5d9afc1.mp3',
  },
  {
    id: 'cartoon_pig',
    name: '卡通猪小琪',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/cartoon-pig-b576952a.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/cartoon_pig-8b19f195.mp3',
  },
  {
    id: 'bingjiao_didi',
    name: '病娇弟弟',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/bingjiao-didi-02e98960.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/bingjiao_didi-216f121d.mp3',
  },
  {
    id: 'junlang_nanyou',
    name: '俊朗男友',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/junlang-nanyou-0cb37caa.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/junlang_nanyou-3b914697.mp3',
  },
  {
    id: 'chunzhen_xuedi',
    name: '纯真学弟',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/chunzhen-xuedi-607619f9.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/chunzhen_xuedi-f6d62f00.mp3',
  },
  {
    id: 'lengdan_xiongzhang',
    name: '冷淡学长',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/lengdan-xiongzhang-f9a85aad.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/lengdan_xiongzhang-2d3d8dff.mp3',
  },
  {
    id: 'badao_shaoye',
    name: '霸道少爷',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/badao-shaoye-4c69e1c0.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/badao_shaoye-4737a720.mp3',
  },
  {
    id: 'tianxin_xiaoling',
    name: '甜心小玲',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/tianxin-xiaoling-ba847c84.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/tianxin_xiaoling-c40e93f6.mp3',
  },
  {
    id: 'qiaopi_mengmei',
    name: '俏皮萌妹',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/qiaopi-mengmei-a578e289.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/qiaopi_mengmei-268f733a.mp3',
  },
  {
    id: 'wumei_yujie',
    name: '妩媚御姐',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/wumei-yujie-a0a4b3d6.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/wumei_yujie-1398069f.mp3',
  },
  {
    id: 'diadia_xuemei',
    name: '嗲嗲学妹',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/diadia-xuemei-4a273051.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/diadia_xuemei-9e592d6a.mp3',
  },
  {
    id: 'danya_xuejie',
    name: '淡雅学姐',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/danya-xuejie-73cfa5a3.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/danya_xuejie-54423ff7.mp3',
  },
  {
    id: 'ai_xndl_sf2_02',
    name: '睿智长者',
    description: '中文普通话',
    img: 'https://image01.vidu.zone/vidu/media-asset/last2-93d0998a.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/last2-6a481578.mp3',
  },
  {
    id: 'English_Deep-VoicedGentleman',
    name: '深沉男声',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/english-deep-voicedgentleman-61021c6f.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/English_Deep_VoicedGentleman-cfb9be30.mp3',
  },
  {
    id: 'English_Diligent_Man',
    name: '自信少年',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/english-diligent-man-adc72d13.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/English_Diligent_Man-bab6aa34.mp3',
  },
  {
    id: 'English_LovelyGirl',
    name: '甜甜女童',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/english-lovelygirl-565f16e0.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/English_LovelyGirl-ecd27a7d.mp3',
  },
  {
    id: 'English_PassionateWarrior',
    name: '热血青年',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/english-passionatewarrior-4c8a2ca7.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/English_PassionateWarrior-16312abb.mp3',
  },
  {
    id: 'English_Graceful_Lady',
    name: '沉稳中年女',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/english-graceful-lady-b9227bfe.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/English_Graceful_Lady-bd2e57a6.mp3',
  },
  {
    id: 'Santa_Claus',
    name: '中年讲述男',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/santa-claus-22d899c0.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Santa_Claus-3f59be29.mp3',
  },
  {
    id: 'Grinch',
    name: '激昂演讲',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/grinch-786362f8.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Grinch-16f17375.mp3',
  },
  {
    id: 'Arnold',
    name: '浑厚男音',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/arnold-e2b09471.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Arnold-a77c20c3.mp3',
  },
  {
    id: 'Charming_Santa',
    name: '低沉男音',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/charming-santa-fbc11f5b.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Charming_Santa-0661a7ea.mp3',
  },
  {
    id: 'Charming_Lady',
    name: '钓系御姐',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/charming-lady-fcef2015.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Charming_Lady-110a702e.mp3',
  },
  {
    id: 'Sweet_Girl',
    name: '柔和女声',
    description: '',
    img: 'https://image01.vidu.zone/vidu/media-asset/sweet-girl-5e7f946c.jpg',
    url: 'https://image01.vidu.zone/vidu/media-asset/Sweet_Girl-d4894034.mp3',
  },
  {
    id: 'Attractive_Girl',
    name: '播音女声',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/attractive-girl-d380422c.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Attractive_Girl-77844e58.mp3',
  },
  {
    id: 'Serene_Woman',
    name: '自然甜妹',
    description: '',
    img: 'https://image01.vidu.zone/vidu/media-asset/serene-woman-ddca5826.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/Serene_Woman-5f3f3aeb.mp3',
  },
  {
    id: 'uk_oldman3',
    name: '资深领袖',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/last5-ec8c2dda.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/last5-155aecc0.mp3',
  },
  {
    id: 'calm_story1',
    name: '沉稳老者',
    description: '英文',
    img: 'https://image01.vidu.zone/vidu/media-asset/last4-132ae2ee.png',
    url: 'https://image01.vidu.zone/vidu/media-asset/last4-200b2418.mp3',
  },
];

// 海外的
const TIMBRE_LIST_GLOBAL: AudioOption[] = [
  {
    id: 'English_Aussie_Bloke',
    name: 'Aussie Bloke',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Aussie_Bloke-81c73051.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Aussie_Bloke-cd23b640.mp3',
  },
  {
    id: 'English_BossyLeader',
    name: 'Bossy Leader',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_BossyLeader-e101e5bb.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_BossyLeader-82b8ee7e.mp3',
  },
  {
    id: 'English_Deep-VoicedGentleman',
    name: 'Deep-voiced Gentleman',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Deep-VoicedGentleman-61021c6f.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Deep-VoicedGentleman-7e87b4cd.mp3',
  },
  {
    id: 'English_Diligent_Man',
    name: 'Diligent Youth',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Diligent_Man-adc72d13.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Diligent_Man-f8344483.mp3',
  },
  {
    id: 'English_Jovialman',
    name: 'Jovial Man',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Jovialman-1abb5e88.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Jovialman-ac0f9bbe.mp3',
  },
  {
    id: 'English_Comedian',
    name: 'Comedian',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Comedian-482822ee.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Comedian-b556c039.mp3',
  },
  {
    id: 'English_LovelyGirl',
    name: 'Lovely Girl',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_LovelyGirl-565f16e0.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_LovelyGirl-286a0328.mp3',
  },
  {
    id: 'English_PassionateWarrior',
    name: 'Passionate Youth',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_PassionateWarrior-4c8a2ca7.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_PassionateWarrior-8cde9d19.mp3',
  },
  {
    id: 'English_SadTeen',
    name: 'Teen Boy',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_SadTeen-55aa3b3d.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_SadTeen-185b9dc0.mp3',
  },
  {
    id: 'English_SentimentalLady',
    name: 'Sentimental Lady',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_SentimentalLady-4f30f913.jpg',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_SentimentalLady-7d22830f.mp3',
  },
  {
    id: 'English_Graceful_Lady',
    name: 'Graceful Lady',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Graceful_Lady-b9227bfe.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Graceful_Lady-bd1104cc.mp3',
  },
  {
    id: 'English_Debator',
    name: 'Male Debater',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Debator-3cb49a8b.jpg',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Debator-362ee2be.mp3',
  },
  {
    id: 'English_MaturePartner',
    name: 'Mature Partner',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_MaturePartner-2262da85.jpg',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_MaturePartner-7adf6736.mp3',
  },
  {
    id: 'English_PlayfulGirl',
    name: 'Playful Girl',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_PlayfulGirl-4316b469.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_PlayfulGirl-aa847fab.mp3',
  },
  {
    id: 'English_ReservedYoungMan',
    name: 'Reserved Young Man',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_ReservedYoungMan-51c586ab.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_ReservedYoungMan-c5224e77.mp3',
  },
  {
    id: 'English_Trustworth_Man',
    name: 'Trustworthy Man',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Trustworth_Man-f937a325.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Trustworth_Man-be415fbd.mp3',
  },
  {
    id: 'English_UpsetGirl',
    name: 'Upset Girl',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_UpsetGirl-9ac32d72.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_UpsetGirl-bd62dd81.mp3',
  },
  {
    id: 'English_Whispering_girl_v3',
    name: 'Whispering girl',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Whispering_girl_v3-fba94a5c.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Whispering_girl_v3-30cc6a6d.mp3',
  },
  {
    id: 'English_Wiselady',
    name: 'Wise Lady',
    img: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Wiselady-7de87383.png',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/English_Wiselady-2595b249.mp3',
  },
];

export const TIMBRE_LIST = SITE === 'china' ? TIMBRE_LIST_CHINA : TIMBRE_LIST_GLOBAL;
